export default __webpack_public_path__ + "static/media/16_4_0.84ced0af.png";